import Amount from '@/types/Amount';

export default class Price {
    public priceId: string;
    public amount: Amount;
    public priceDateTime: Date;
}
